module.exports = __webpack_public_path__ + "img/insurance-icon.ba8e053d.svg";